// import React, { useState, useEffect } from 'react';
// import { AlertCircle, CheckCircle, Eye, EyeOff, ArrowLeft } from 'lucide-react';

// function Login({ onLogin }) {
//   // State management for different auth modes
//   const [authMode, setAuthMode] = useState('login'); // 'login', 'signup', 'forgotPassword'
//   const [isMobile, setIsMobile] = useState(false);
  
//   // Form data for all modes
//   const [formData, setFormData] = useState({
//     // Login fields
//     loginId: '',
//     password: '',
//     rememberDevice: false,
//     // Signup fields
//     name: '',
//     email: '',
//     signupPassword: '',
//     confirmPassword: '',
//     // Forgot password field
//     resetEmail: ''
//   });

//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [fieldErrors, setFieldErrors] = useState({
//     name: '',
//     email: '',
//     signupPassword: '',
//     confirmPassword: ''
//   });

//   const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

//   // Mobile detection hook
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   useEffect(() => {
//     // Load Lexend font
//     const link = document.createElement('link');
//     link.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&display=swap';
//     link.rel = 'stylesheet';
//     if (!document.head.querySelector('link[href*="Lexend"]')) {
//       document.head.appendChild(link);
//     }

//     return () => {
//       const existingLink = document.head.querySelector('link[href*="Lexend"]');
//       if (existingLink) {
//         document.head.removeChild(existingLink);
//       }
//     };
//   }, []);

//   // Clear messages and form when switching modes
//   const switchAuthMode = (mode) => {
//     setAuthMode(mode);
//     setError('');
//     setSuccessMessage('');
//     setIsLoading(false);
//     setFieldErrors({
//       name: '',
//       email: '',
//       signupPassword: '',
//       confirmPassword: ''
//     });
//     setFormData({
//       loginId: '',
//       password: '',
//       rememberDevice: false,
//       name: '',
//       email: '',
//       signupPassword: '',
//       confirmPassword: '',
//       resetEmail: ''
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     setFormData({
//       ...formData,
//       [name]: type === 'checkbox' ? checked : value
//     });
    
//     // Real-time validation for signup fields
//     if (authMode === 'signup') {
//       let fieldError = '';
      
//       switch (name) {
//         case 'name':
//           fieldError = validateName(value);
//           break;
//         case 'email':
//           fieldError = validateEmail(value);
//           break;
//         case 'signupPassword':
//           fieldError = validatePassword(value);
//           // Also check confirm password if it exists
//           if (formData.confirmPassword && value !== formData.confirmPassword) {
//             setFieldErrors(prev => ({...prev, confirmPassword: 'Passwords do not match'}));
//           } else if (formData.confirmPassword && value === formData.confirmPassword) {
//             setFieldErrors(prev => ({...prev, confirmPassword: ''}));
//           }
//           break;
//         case 'confirmPassword':
//           if (formData.signupPassword && value !== formData.signupPassword) {
//             fieldError = 'Passwords do not match';
//           }
//           break;
//         default:
//           break;
//       }
      
//       setFieldErrors(prev => ({
//         ...prev,
//         [name]: fieldError
//       }));
//     }
    
//     // Clear main error when user starts typing
//     if (error) {
//       setError('');
//     }
//   };

//   const handleLoginSubmit = async () => {
//     setIsLoading(true);
//     setError('');
//     setSuccessMessage('');

//     if (!formData.loginId || !formData.password) {
//       setError('Please enter both your email/client ID and password');
//       setIsLoading(false);
//       return;
//     }

//     try {
//       // Normalize EMAIL if it's an email input
//       let normalizedLoginId = formData.loginId.trim();
//       if (normalizedLoginId.includes('@')) {
//         normalizedLoginId = normalizedLoginId.toLowerCase();
//         console.log('📧 Normalized login email to:', normalizedLoginId);
//       }

//       const response = await fetch(`${API_URL}/auth/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           loginId: normalizedLoginId,
//           password: formData.password,
//           rememberDevice: formData.rememberDevice || false
//         })
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Login failed');
//       }

//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user));

//       if (formData.rememberDevice) {
//         localStorage.setItem('rememberDevice', 'true');
//       }

//       let successMsg = 'Login successful!';
//       if (data.loginType === 'existing_user_first_login') {
//         successMsg = 'Welcome! Your password has been set successfully.';
//       } else if (data.loginType === 'new_user') {
//         successMsg = 'Welcome to your dashboard!';
//       } else if (data.loginType === 'password_reset') {
//         successMsg = 'Password reset successful! Welcome back.';
//       }

//       setSuccessMessage(successMsg);

//       if (onLogin) {
//         onLogin(data.user);
//       }

//     } catch (error) {
//       setError(error.message || 'An error occurred during login');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // SIGNUP HANDLER
//   const handleSignupSubmit = async () => {
//     setIsLoading(true);
//     setError('');
//     setSuccessMessage('');

//     if (!formData.name || !formData.email || !formData.signupPassword || !formData.confirmPassword) {
//       setError('Please fill in all fields');
//       setIsLoading(false);
//       return;
//     }

//     if (formData.signupPassword !== formData.confirmPassword) {
//       setError('Passwords do not match');
//       setIsLoading(false);
//       return;
//     }

//     if (formData.signupPassword.length < 8) {
//       setError('Password must be at least 8 characters long');
//       setIsLoading(false);
//       return;
//     }

//     try {
// const response = await fetch(`${API_URL}/auth/signup`, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify({
//     firstName: formData.name.trim().split(' ')[0] || formData.name.trim(),
//     lastName: formData.name.trim().split(' ').slice(1).join(' ') || '',
//     email: formData.email.trim().toLowerCase(), // Add .toLowerCase()
//     password: formData.signupPassword
//   })
// });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Signup failed');
//       }

//       setSuccessMessage('Account created successfully! You can now sign in with your credentials.');
      
//       setTimeout(() => {
//         switchAuthMode('login');
//       }, 2000);

//     } catch (error) {
//       setError(error.message || 'An error occurred during signup');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleForgotPasswordSubmit = async () => {
//     setIsLoading(true);
//     setError('');
//     setSuccessMessage('');

//     if (!formData.resetEmail) {
//       setError('Please enter your email address');
//       setIsLoading(false);
//       return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.resetEmail)) {
//       setError('Please enter a valid email address');
//       setIsLoading(false);
//       return;
//     }

//     try {
//       // Normalize EMAIL before sending reset request
//       const normalizedEmail = formData.resetEmail.toLowerCase().trim();
//       console.log('📧 Sending reset request for normalized email:', normalizedEmail);

//       const response = await fetch(`${API_URL}/auth/reset-password-request`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: normalizedEmail
//         })
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Failed to send reset link');
//       }

//       setSuccessMessage('Password reset link sent! Check your email and follow the instructions to reset your password and sign in again.');

//     } catch (error) {
//       setError(error.message || 'An error occurred while sending the reset link');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Validation functions
//   const validateName = (name) => {
//     if (!name.trim()) return '';
//     const nameRegex = /^[a-zA-Z\s]+$/;
//     if (!nameRegex.test(name.trim())) {
//       return 'Name should only contain letters and spaces, no numbers or special characters';
//     }
//     return '';
//   };

//   const validateEmail = (email) => {
//     if (!email.trim()) return '';
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
//     if (!emailRegex.test(email)) {
//       if (!email.includes('@')) {
//         return 'Email must contain an @ symbol';
//       } else if (!email.includes('.')) {
//         return 'Email must contain a valid domain (e.g., .com, .org)';
//       } else if (email.indexOf('@') > email.lastIndexOf('.')) {
//         return 'Email format is invalid - domain should come after @';
//       } else {
//         return 'Please enter a valid email address';
//       }
//     }
//     return '';
//   };

//   const validatePassword = (password) => {
//     if (!password) return '';
//     if (password.length < 8) {
//       return 'Password must be at least 8 characters long';
//     }
//     const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
//     if (!specialCharRegex.test(password)) {
//       return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
//     }
//     return '';
//   };

//   const handleSocialLogin = (provider) => {
//     const authUrl = `${API_URL}/auth/${provider}`;
//     window.location.href = authUrl;
//   };

//   const getPageContent = () => {
//     switch (authMode) {
//       case 'signup':
//         return {
//           title: 'Create Account',
//           subtitle: 'Join AB Nexus to access institutional portfolio management'
//         };
//       case 'forgotPassword':
//         return {
//           title: 'Reset Password',
//           subtitle: 'Enter your email to receive password reset instructions'
//         };
//       default:
//         return {
//           title: 'Portal Access',
//           subtitle: 'Sign in to view your portfolio performance and investment analytics'
//         };
//     }
//   };

//   // Mobile-responsive AB Nexus Logo Component
//   const ABNexusLogo = () => (
//     <div className="flex items-center mb-6 sm:mb-8">
//       <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 mr-3 sm:mr-4 relative">
//         <img 
//           src="/images/logoOnly.png" 
//           alt="AB Nexus Logo" 
//           className="w-full h-full object-contain"
//         />
//       </div>
//       <div className="text-white text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-wide">AB NEXUS</div>
//     </div>
//   );

//   const pageContent = getPageContent();

//   return (
//     <div 
//       className="min-h-screen flex items-center justify-center p-4 sm:p-6 relative overflow-hidden"
//       style={{
//         fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
//         background: '#0A0A0A'
//       }}
//     >
//       {/* Background Effects */}
//       <div className="fixed inset-0 z-0">
//         <div 
//           className="absolute inset-0"
//           style={{
//             background: `
//               radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
//               radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
//             `
//           }}
//         />
//         <div 
//           className="absolute inset-0 opacity-30"
//           style={{
//             backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(103, 109, 255, 0.15) 1px, transparent 0)',
//             backgroundSize: '40px 40px'
//           }}
//         />
//       </div>

//       {/* Loading Overlay */}
//       {isLoading && (
//         <div className="fixed inset-0 bg-black bg-opacity-95 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-6 h-6 sm:w-8 sm:h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin"></div>
//         </div>
//       )}

//       {/* Main Container - Mobile responsive */}
//       <div 
//         className="w-full max-w-6xl min-h-[600px] max-h-[90vh] grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] relative z-10 overflow-hidden"
//         style={{
//           background: 'rgba(21, 21, 21, 0.95)',
//           backdropFilter: 'blur(20px)',
//           border: '1px solid rgba(103, 109, 255, 0.2)',
//           borderRadius: '24px',
//           boxShadow: `
//             0 25px 50px rgba(0, 0, 0, 0.5),
//             0 0 0 1px rgba(103, 109, 255, 0.1),
//             inset 0 1px 0 rgba(255, 255, 255, 0.05)
//           `
//         }}
//       >
//         {/* Brand Section - Hidden on mobile */}
//         <div 
//           className="hidden lg:flex flex-col p-8 lg:p-12 relative overflow-hidden text-white"
//           style={{
//             background: 'linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%)',
//             borderRight: '1px solid rgba(103, 109, 255, 0.2)',
//             paddingTop: '2.3rem'
//           }}
//         >
//           <div 
//             className="absolute inset-0"
//             style={{
//               backgroundImage: `
//                 linear-gradient(30deg, transparent 12%, rgba(103, 109, 255, 0.08) 12%, rgba(103, 109, 255, 0.08) 14%, transparent 14%),
//                 linear-gradient(90deg, transparent 24%, rgba(103, 109, 255, 0.05) 25%, rgba(103, 109, 255, 0.05) 26%, transparent 27%),
//                 radial-gradient(circle at 20% 80%, rgba(103, 109, 255, 0.1) 0%, transparent 40%),
//                 radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.02) 0%, transparent 40%)
//               `,
//               backgroundSize: '60px 40px, 60px 40px, 300px 300px, 200px 200px'
//             }}
//           />

//           <div 
//             className="absolute top-[15%] right-[-50px] w-40 h-40 rounded-full opacity-75"
//             style={{
//               background: 'radial-gradient(circle, rgba(103, 109, 255, 0.25), rgba(103, 109, 255, 0.1) 50%, transparent 70%)',
//               filter: 'blur(60px)',
//               animation: 'float 8s ease-in-out infinite'
//             }}
//           />

//           <div className="relative z-10">
//             <ABNexusLogo />
            
//             <div className="mb-10 relative pl-5">
//               <div 
//                 className="absolute left-0 top-2 w-1 h-10 rounded"
//                 style={{
//                   background: 'linear-gradient(180deg, #676DFF, rgba(103, 109, 255, 0.3))'
//                 }}
//               />
//               <p className="text-base text-gray-300 leading-relaxed font-normal">
//                 Professional portfolio management platform designed for institutional investors and wealth managers
//               </p>
//             </div>

//             <div 
//               className="grid grid-cols-2 gap-6 mb-8 relative p-2"
//               style={{
//                 background: 'rgba(103, 109, 255, 0.03)',
//                 border: '1px solid rgba(103, 109, 255, 0.1)',
//                 borderRadius: '12px'
//               }}
//             >
//               <div className="text-left p-4">
//                 <span 
//                   className="text-3xl font-bold block mb-2"
//                   style={{ color: '#676DFF' }}
//                 >
//                   $1.5M+
//                 </span>
//                 <span className="text-sm text-gray-400">Assets Under Management</span>
//               </div>
//               <div className="text-left p-4">
//                 <span 
//                   className="text-3xl font-bold block mb-2"
//                   style={{ color: '#676DFF' }}
//                 >
//                   100+
//                 </span>
//                 <span className="text-sm text-gray-400">No of Investors</span>
//               </div>
//             </div>

//             <div className="relative">
//               <ul className="space-y-4 pl-1">
//                 {[
//                   'Real-time NAV calculation and portfolio analytics',
//                   'Multi-strategy investment tracking and reporting', 
//                   'Institutional-grade security and compliance',
//                   'Advanced performance attribution analysis'
//                 ].map((feature, index) => (
//                   <li key={index} className="flex items-center text-sm text-gray-200 font-normal hover:text-white hover:translate-x-1 transition-all duration-300">
//                     <div 
//                       className="w-1.5 h-1.5 rounded-full mr-4 flex-shrink-0"
//                       style={{ 
//                         background: '#676DFF',
//                         boxShadow: '0 0 8px rgba(103, 109, 255, 0.4)'
//                       }}
//                     />
//                     {feature}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>

//         {/* Form Section - Mobile responsive */}
//         <div 
//           className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center relative"
//           style={{ background: 'rgba(15, 15, 15, 0.8)' }}
//         >
//           {/* Mobile logo */}
//           <div className="lg:hidden mb-6 sm:mb-8 text-center">
//             <ABNexusLogo />
//           </div>

//           <div className="mb-8 sm:mb-10">
//             {authMode !== 'login' && (
//               <button
//                 onClick={() => switchAuthMode('login')}
//                 className="flex items-center gap-2 text-gray-400 hover:text-white mb-4 transition-colors duration-200"
//               >
//                 <ArrowLeft className="w-4 h-4" />
//                 <span className="text-sm">Back to Login</span>
//               </button>
//             )}
//             <h1 className="text-2xl sm:text-3xl font-semibold text-white mb-2 tracking-tight">
//               {pageContent.title}
//             </h1>
//             <p className="text-gray-400 text-sm leading-relaxed">
//               {pageContent.subtitle}
//             </p>
//           </div>

//           {/* Error Message */}
//           {error && (
//             <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
//               <div className="flex">
//                 <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
//                 <span className="text-xs sm:text-sm">{error}</span>
//               </div>
//             </div>
//           )}

//           {/* Success Message */}
//           {successMessage && (
//             <div className="bg-green-900 bg-opacity-20 border border-green-800 text-green-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
//               <div className="flex">
//                 <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
//                 <span className="text-xs sm:text-sm">{successMessage}</span>
//               </div>
//             </div>
//           )}

//           {/* LOGIN FORM */}
//           {authMode === 'login' && (
//             <div className="space-y-4 sm:space-y-6">
//               <div>
//                 <label htmlFor="loginId" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Client ID / Email
//                 </label>
//                 <input
//                   type="text"
//                   id="loginId"
//                   name="loginId"
//                   value={formData.loginId}
//                   onChange={handleChange}
//                   className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border border-gray-600 text-white text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
//                   style={{
//                     background: 'rgba(21, 21, 21, 0.8)',
//                     backdropFilter: 'blur(10px)',
//                     fontFamily: 'Lexend, sans-serif'
//                   }}
//                   placeholder="Enter your client identifier"
//                   required
//                 />
//               </div>

//               <div>
//                 <label htmlFor="password" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="password"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     className="w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border border-gray-600 text-white text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
//                     style={{
//                       background: 'rgba(21, 21, 21, 0.8)',
//                       backdropFilter: 'blur(10px)',
//                       fontFamily: 'Lexend, sans-serif'
//                     }}
//                     placeholder="Enter your secure password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                   </button>
//                 </div>
//               </div>

//               <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center text-sm space-y-2 sm:space-y-0">
//                 <label className="flex items-center gap-2 text-gray-300 cursor-pointer">
//                   <input 
//                     type="checkbox" 
//                     name="rememberDevice"
//                     checked={formData.rememberDevice}
//                     onChange={handleChange}
//                     className="w-4 h-4 rounded border-gray-600" 
//                     style={{ accentColor: '#676DFF' }} 
//                   />
//                   <span>Remember this device</span>
//                 </label>
//                 <button
//                   type="button"
//                   onClick={() => switchAuthMode('forgotPassword')}
//                   className="font-medium transition-colors duration-200 text-left sm:text-right"
//                   style={{ color: '#676DFF' }}
//                 >
//                   Reset Password
//                 </button>
//               </div>

//               <button
//                 type="button"
//                 onClick={handleLoginSubmit}
//                 disabled={isLoading}
//                 className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
//                 style={{
//                   background: 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
//                   boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
//                 }}
//               >
//                 {isLoading ? 'Authenticating...' : 'Access Portfolio Dashboard'}
//               </button>

//               <div className="relative text-center my-5 sm:my-7">
//                 <div className="absolute inset-0 flex items-center">
//                   <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, #505050, transparent)' }} />
//                 </div>
//                 <span className="bg-black bg-opacity-90 px-4 text-xs text-gray-400 relative">or authenticate with</span>
//               </div>

//               <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-5 sm:mb-7">
//                 <button
//                   type="button"
//                   onClick={() => handleSocialLogin('Google')}
//                   className="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-600 rounded-lg text-gray-300 text-xs font-medium transition-all duration-300 hover:border-purple-500 hover:bg-gray-800"
//                   style={{ background: 'rgba(21, 21, 21, 0.6)' }}
//                 >
//                   <svg width="14" height="14" viewBox="0 0 24 24">
//                     <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
//                     <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
//                     <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
//                     <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
//                   </svg>
//                   <span className="hidden sm:inline">Google SSO</span>
//                   <span className="sm:hidden">Google</span>
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => handleSocialLogin('Microsoft')}
//                   className="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-600 rounded-lg text-gray-300 text-xs font-medium transition-all duration-300 hover:border-purple-500 hover:bg-gray-800"
//                   style={{ background: 'rgba(21, 21, 21, 0.6)' }}
//                 >
//                   <svg width="14" height="14" viewBox="0 0 24 24">
//                     <path fill="#00BCF2" d="M0 0h11v11H0z"/>
//                     <path fill="#00B7F2" d="M13 0h11v11H13z"/>
//                     <path fill="#FFB900" d="M0 13h11v11H0z"/>
//                     <path fill="#00D800" d="M13 13h11v11H13z"/>
//                   </svg>
//                   Microsoft
//                 </button>
//               </div>

//               <div className="text-center">
//                 <p className="text-sm text-gray-400">
//                   Don't have an account?{' '}
//                   <button
//                     type="button"
//                     onClick={() => switchAuthMode('signup')}
//                     className="font-medium transition-colors duration-200"
//                     style={{ color: '#676DFF' }}
//                   >
//                     Sign up
//                   </button>
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* SIGNUP FORM - Mobile responsive */}
//           {authMode === 'signup' && (
//             <div className="space-y-4 sm:space-y-6">
//               {/* NAME INPUT */}
//               <div>
//                 <label htmlFor="name" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Full Name
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   value={formData.name || ''}
//                   onChange={handleChange}
//                   className={`w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                     fieldErrors.name 
//                       ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                       : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                   }`}
//                   style={{
//                     background: 'rgba(21, 21, 21, 0.8)',
//                     backdropFilter: 'blur(10px)',
//                     fontFamily: 'Lexend, sans-serif'
//                   }}
//                   placeholder="Enter your full name"
//                   required
//                 />
//                 {fieldErrors.name && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.name}
//                   </p>
//                 )}
//               </div>

//               {/* EMAIL INPUT */}
//               <div>
//                 <label htmlFor="email" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Email Address
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email || ''}
//                   onChange={handleChange}
//                   className={`w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                     fieldErrors.email 
//                       ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                       : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                   }`}
//                   style={{
//                     background: 'rgba(21, 21, 21, 0.8)',
//                     backdropFilter: 'blur(10px)',
//                     fontFamily: 'Lexend, sans-serif'
//                   }}
//                   placeholder="Enter your email address"
//                   required
//                 />
//                 {fieldErrors.email && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.email}
//                   </p>
//                 )}
//               </div>

//               {/* PASSWORD INPUT */}
//               <div>
//                 <label htmlFor="signupPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     id="signupPassword"
//                     name="signupPassword"
//                     value={formData.signupPassword || ''}
//                     onChange={handleChange}
//                     className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                       fieldErrors.signupPassword 
//                         ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                         : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                     }`}
//                     style={{
//                       background: 'rgba(21, 21, 21, 0.8)',
//                       backdropFilter: 'blur(10px)',
//                       fontFamily: 'Lexend, sans-serif'
//                     }}
//                     placeholder="Create a secure password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                   </button>
//                 </div>
//                 {fieldErrors.signupPassword && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.signupPassword}
//                   </p>
//                 )}
//               </div>

//               {/* CONFIRM PASSWORD INPUT */}
//               <div>
//                 <label htmlFor="confirmPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Confirm Password
//                 </label>
//                 <div className="relative">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     id="confirmPassword"
//                     name="confirmPassword"
//                     value={formData.confirmPassword || ''}
//                     onChange={handleChange}
//                     className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
//                       fieldErrors.confirmPassword 
//                         ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
//                         : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
//                     }`}
//                     style={{
//                       background: 'rgba(21, 21, 21, 0.8)',
//                       backdropFilter: 'blur(10px)',
//                       fontFamily: 'Lexend, sans-serif'
//                     }}
//                     placeholder="Confirm your password"
//                     required
//                   />
//                   <button
//                     type="button"
//                     className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
//                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   >
//                     {showConfirmPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                   </button>
//                 </div>
//                 {fieldErrors.confirmPassword && (
//                   <p className="text-red-400 text-xs mt-2 flex items-center">
//                     <AlertCircle className="w-3 h-3 mr-1" />
//                     {fieldErrors.confirmPassword}
//                   </p>
//                 )}
//               </div>

//               {/* SUBMIT BUTTON */}
//               <div className="pt-2">
//                 <button
//                   type="button"
//                   onClick={handleSignupSubmit}
//                   disabled={isLoading}
//                   className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
//                   style={{
//                     background: isLoading 
//                       ? '#4a5568' 
//                       : 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
//                     boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
//                   }}
//                 >
//                   {isLoading ? (
//                     <span className="flex items-center justify-center">
//                       <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                       Creating Account...
//                     </span>
//                   ) : (
//                     'Create Account'
//                   )}
//                 </button>
//               </div>

//               {/* SIGN IN LINK */}
//               <div className="text-center">
//                 <p className="text-sm text-gray-400">
//                   Already have an account?{' '}
//                   <button
//                     type="button"
//                     onClick={() => switchAuthMode('login')}
//                     className="font-medium transition-colors duration-200"
//                     style={{ color: '#676DFF' }}
//                   >
//                     Sign In
//                   </button>
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* FORGOT PASSWORD FORM */}
//           {authMode === 'forgotPassword' && (
//             <div className="space-y-4 sm:space-y-6">
//               <div>
//                 <label htmlFor="resetEmail" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
//                   Email Address
//                 </label>
//                 <input
//                   type="email"
//                   id="resetEmail"
//                   name="resetEmail"
//                   value={formData.resetEmail}
//                   onChange={handleChange}
//                   className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border border-gray-600 text-white text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
//                   style={{
//                     background: 'rgba(21, 21, 21, 0.8)',
//                     backdropFilter: 'blur(10px)',
//                     fontFamily: 'Lexend, sans-serif'
//                   }}
//                   placeholder="Enter your email address"
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-2">
//                   We'll send you a secure link to reset your password
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 onClick={handleForgotPasswordSubmit}
//                 disabled={isLoading}
//                 className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
//                 style={{
//                   background: 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
//                   boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
//                 }}
//               >
//                 {isLoading ? 'Sending Reset Link...' : 'Send Reset Link'}
//               </button>

//               <div className="text-center">
//                 <p className="text-sm text-gray-400">
//                   Remember your password?{' '}
//                   <button
//                     type="button"
//                     onClick={() => switchAuthMode('login')}
//                     className="font-medium transition-colors duration-200"
//                     style={{ color: '#676DFF' }}
//                   >
//                     Sign In
//                   </button>
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(180deg); }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Login;

import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle, Eye, EyeOff, ArrowLeft } from 'lucide-react';
import { useTheme } from '../theme/ThemeContext';

function Login({ onLogin }) {
  const { theme, setTheme } = useTheme();
  const isLight = theme === 'light';
  // State management for different auth modes
  const [authMode, setAuthMode] = useState('login'); // 'login', 'signup', 'forgotPassword'
  const [isMobile, setIsMobile] = useState(false);
  
  // Form data for all modes
  const [formData, setFormData] = useState({
    // Login fields
    loginId: '',
    password: '',
    rememberDevice: false,
    // Signup fields
    name: '',
    email: '',
    signupPassword: '',
    confirmPassword: '',
    // Forgot password field
    resetEmail: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: '',
    email: '',
    signupPassword: '',
    confirmPassword: ''
  });

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // Mobile detection hook
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Load Lexend font
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    if (!document.head.querySelector('link[href*="Lexend"]')) {
      document.head.appendChild(link);
    }

    return () => {
      const existingLink = document.head.querySelector('link[href*="Lexend"]');
      if (existingLink) {
        document.head.removeChild(existingLink);
      }
    };
  }, []);

  // Clear messages and form when switching modes
  const switchAuthMode = (mode) => {
    setAuthMode(mode);
    setError('');
    setSuccessMessage('');
    setIsLoading(false);
    setFieldErrors({
      name: '',
      email: '',
      signupPassword: '',
      confirmPassword: ''
    });
    setFormData({
      loginId: '',
      password: '',
      rememberDevice: false,
      name: '',
      email: '',
      signupPassword: '',
      confirmPassword: '',
      resetEmail: ''
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    // Real-time validation for signup fields
    if (authMode === 'signup') {
      let fieldError = '';
      
      switch (name) {
        case 'name':
          fieldError = validateName(value);
          break;
        case 'email':
          fieldError = validateEmail(value);
          break;
        case 'signupPassword':
          fieldError = validatePassword(value);
          // Also check confirm password if it exists
          if (formData.confirmPassword && value !== formData.confirmPassword) {
            setFieldErrors(prev => ({...prev, confirmPassword: 'Passwords do not match'}));
          } else if (formData.confirmPassword && value === formData.confirmPassword) {
            setFieldErrors(prev => ({...prev, confirmPassword: ''}));
          }
          break;
        case 'confirmPassword':
          if (formData.signupPassword && value !== formData.signupPassword) {
            fieldError = 'Passwords do not match';
          }
          break;
        default:
          break;
      }
      
      setFieldErrors(prev => ({
        ...prev,
        [name]: fieldError
      }));
    }
    
    // Clear main error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleLoginSubmit = async () => {
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    if (!formData.loginId || !formData.password) {
      const errorMsg = 'Please enter both your email/client ID and password';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    try {
      // Normalize EMAIL if it's an email input
      let normalizedLoginId = formData.loginId.trim();
      if (normalizedLoginId.includes('@')) {
        normalizedLoginId = normalizedLoginId.toLowerCase();
        console.log('📧 Normalized login email to:', normalizedLoginId);
      }

      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          loginId: normalizedLoginId,
          password: formData.password,
          rememberDevice: formData.rememberDevice || false
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      if (formData.rememberDevice) {
        localStorage.setItem('rememberDevice', 'true');
      }

      let successMsg = 'Login successful!';
      if (data.loginType === 'existing_user_first_login') {
        successMsg = 'Welcome! Your password has been set successfully.';
      } else if (data.loginType === 'new_user') {
        successMsg = 'Welcome to your dashboard!';
      } else if (data.loginType === 'password_reset') {
        successMsg = 'Password reset successful! Welcome back.';
      }

      setSuccessMessage(successMsg);

      if (onLogin) {
        onLogin(data.user);
      }

    } catch (error) {
      const errorMessage = error.message || 'An error occurred during login';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // SIGNUP HANDLER
  const handleSignupSubmit = async () => {
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    if (!formData.name || !formData.email || !formData.signupPassword || !formData.confirmPassword) {
      const errorMsg = 'Please fill in all fields';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    if (formData.signupPassword !== formData.confirmPassword) {
      const errorMsg = 'Passwords do not match';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    if (formData.signupPassword.length < 8) {
      const errorMsg = 'Password must be at least 8 characters long';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: formData.name.trim().split(' ')[0] || formData.name.trim(),
          lastName: formData.name.trim().split(' ').slice(1).join(' ') || '',
          email: formData.email.trim().toLowerCase(),
          password: formData.signupPassword
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Signup failed');
      }

      setSuccessMessage('Account created successfully! You can now sign in with your credentials.');
      
      setTimeout(() => {
        switchAuthMode('login');
      }, 2000);

    } catch (error) {
      const errorMessage = error.message || 'An error occurred during signup';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPasswordSubmit = async () => {
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    if (!formData.resetEmail) {
      const errorMsg = 'Please enter your email address';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.resetEmail)) {
      const errorMsg = 'Please enter a valid email address';
      setError(errorMsg);
      setIsLoading(false);
      return;
    }

    try {
      // Normalize EMAIL before sending reset request
      const normalizedEmail = formData.resetEmail.toLowerCase().trim();
      console.log('📧 Sending reset request for normalized email:', normalizedEmail);

      const response = await fetch(`${API_URL}/auth/reset-password-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: normalizedEmail
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to send reset link');
      }

      setSuccessMessage('Password reset link sent! Check your email and follow the instructions to reset your password and sign in again.');

    } catch (error) {
      const errorMessage = error.message || 'An error occurred while sending the reset link';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // Validation functions
  const validateName = (name) => {
    if (!name.trim()) return '';
    const nameRegex = /^[a-zA-Z\s]+$/;
    if (!nameRegex.test(name.trim())) {
      return 'Name should only contain letters and spaces, no numbers or special characters';
    }
    return '';
  };

  const validateEmail = (email) => {
    if (!email.trim()) return '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
      if (!email.includes('@')) {
        return 'Email must contain an @ symbol';
      } else if (!email.includes('.')) {
        return 'Email must contain a valid domain (e.g., .com, .org)';
      } else if (email.indexOf('@') > email.lastIndexOf('.')) {
        return 'Email format is invalid - domain should come after @';
      } else {
        return 'Please enter a valid email address';
      }
    }
    return '';
  };

  const validatePassword = (password) => {
    if (!password) return '';
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    if (!specialCharRegex.test(password)) {
      return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
    }
    return '';
  };

  const handleSocialLogin = (provider) => {
    const authUrl = `${API_URL}/auth/${provider.toLowerCase()}`;
    window.location.href = authUrl;
  };

  const getPageContent = () => {
    switch (authMode) {
      case 'signup':
        return {
          title: 'Create Account',
          subtitle: 'Join AB Nexus to access institutional portfolio management'
        };
      case 'forgotPassword':
        return {
          title: 'Reset Password',
          subtitle: 'Enter your email to receive password reset instructions'
        };
      default:
        return {
          title: 'Portal Access',
          subtitle: 'Sign in to view your portfolio performance and investment analytics'
        };
    }
  };

  // Mobile-responsive AB Nexus Logo Component
  const ABNexusLogo = () => (
    <div className="flex items-center mb-6 sm:mb-8">
      <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 mr-3 sm:mr-4 relative">
        <img 
          src="/images/logoOnly.png" 
          alt="AB Nexus Logo" 
          className="w-full h-full object-contain"
        />
      </div>
      <div className="text-white text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-wide">AB NEXUS</div>
    </div>
  );

  const pageContent = getPageContent();

  const palette = {
    surface: isLight ? '#ffffff' : 'var(--bg-surface-95)',
    surfaceAlt: isLight ? '#f7f8ff' : 'var(--bg-surface-80)',
    border: isLight ? '#d5d7e0' : 'var(--border-subtle)',
    textPrimary: isLight ? '#0f172a' : 'var(--text-primary)',
    textMuted: isLight ? '#475569' : 'var(--text-muted)',
    textSubtle: isLight ? '#6b7280' : 'var(--text-subtle)',
  };

  // Force dark theme on login page load to avoid light-mode layout issues
  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 sm:p-6 relative overflow-hidden"
      style={{
        fontFamily: 'Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        background: isLight ? '#f4f6ff' : 'var(--bg-base)'
      }}
    >
      {/* Background Effects */}
      <div className="fixed inset-0 z-0">
        <div 
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(circle at 25% 25%, rgba(103, 109, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 75% 75%, rgba(103, 109, 255, 0.05) 0%, transparent 50%)
            `
          }}
        />
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(103, 109, 255, 0.15) 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}
        />
      </div>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-95 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="w-6 h-6 sm:w-8 sm:h-8 border-2 border-gray-600 border-t-purple-500 rounded-full animate-spin"></div>
        </div>
      )}

      {/* Main Container - Mobile responsive */}
      <div 
        className="w-full max-w-6xl min-h-[600px] max-h-[90vh] grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] relative z-10 overflow-hidden"
        style={{
          background: palette.surface,
          backdropFilter: 'blur(20px)',
          border: `1px solid ${palette.border}`,
          borderRadius: '24px',
          boxShadow: `
            0 25px 50px rgba(0, 0, 0, 0.5),
            0 0 0 1px rgba(103, 109, 255, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.05)
          `
        }}
      >
        {/* Brand Section - Hidden on mobile */}
        <div 
          className="hidden lg:flex flex-col p-8 lg:p-12 relative overflow-hidden text-white"
          style={{
            background: isLight 
              ? 'linear-gradient(135deg, #ffffff 0%, #eef2ff 100%)'
              : 'linear-gradient(135deg, var(--bg-surface) 0%, var(--bg-base) 100%)',
            borderRight: `1px solid ${palette.border}`,
            paddingTop: '2.3rem'
          }}
        >
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `
                linear-gradient(30deg, transparent 12%, rgba(103, 109, 255, 0.08) 12%, rgba(103, 109, 255, 0.08) 14%, transparent 14%),
                linear-gradient(90deg, transparent 24%, rgba(103, 109, 255, 0.05) 25%, rgba(103, 109, 255, 0.05) 26%, transparent 27%),
                radial-gradient(circle at 20% 80%, rgba(103, 109, 255, 0.1) 0%, transparent 40%),
                radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.02) 0%, transparent 40%)
              `,
              backgroundSize: '60px 40px, 60px 40px, 300px 300px, 200px 200px'
            }}
          />

          <div 
            className="absolute top-[15%] right-[-50px] w-40 h-40 rounded-full opacity-75"
            style={{
              background: 'radial-gradient(circle, rgba(103, 109, 255, 0.25), rgba(103, 109, 255, 0.1) 50%, transparent 70%)',
              filter: 'blur(60px)',
              animation: 'float 8s ease-in-out infinite'
            }}
          />

          <div className="relative z-10">
            <ABNexusLogo />
            
            <div className="mb-10 relative pl-5">
              <div 
                className="absolute left-0 top-2 w-1 h-10 rounded"
                style={{
                  background: 'linear-gradient(180deg, #676DFF, rgba(103, 109, 255, 0.3))'
                }}
              />
              <p className="text-base text-gray-300 leading-relaxed font-normal">
                Professional portfolio management platform designed for institutional investors and wealth managers
              </p>
            </div>

            <div 
              className="grid grid-cols-2 gap-6 mb-8 relative p-2"
              style={{
                background: 'rgba(103, 109, 255, 0.03)',
                border: '1px solid rgba(103, 109, 255, 0.1)',
                borderRadius: '12px'
              }}
            >
              <div className="text-left p-4">
                <span 
                  className="text-3xl font-bold block mb-2"
                  style={{ color: '#676DFF' }}
                >
                  $2M+
                </span>
                <span className="text-sm text-gray-400">Assets Under Management</span>
              </div>
              <div className="text-left p-4">
                <span 
                  className="text-3xl font-bold block mb-2"
                  style={{ color: '#676DFF' }}
                >
                  100+
                </span>
                <span className="text-sm text-gray-400">No of Investors</span>
              </div>
            </div>

            <div className="relative">
              <ul className="space-y-4 pl-1">
                {[
                  'Real-time NAV calculation and portfolio analytics',
                  'Multi-strategy investment tracking and reporting', 
                  'Institutional-grade security and compliance',
                  'Advanced performance attribution analysis'
                ].map((feature, index) => (
                  <li key={index} className="flex items-center text-sm text-gray-200 font-normal hover:text-white hover:translate-x-1 transition-all duration-300">
                    <div 
                      className="w-1.5 h-1.5 rounded-full mr-4 flex-shrink-0"
                      style={{ 
                        background: '#676DFF',
                        boxShadow: '0 0 8px rgba(103, 109, 255, 0.4)'
                      }}
                    />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Form Section - Mobile responsive */}
        <div 
          className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center relative"
          style={{ background: 'rgba(15, 15, 15, 0.8)' }}
        >
          {/* Mobile logo */}
          <div className="lg:hidden mb-6 sm:mb-8 text-center">
            <ABNexusLogo />
          </div>

          <div className="mb-8 sm:mb-10">
            {authMode !== 'login' && (
              <button
                onClick={() => switchAuthMode('login')}
                className="flex items-center gap-2 text-gray-400 hover:text-white mb-4 transition-colors duration-200"
              >
                <ArrowLeft className="w-4 h-4" />
                <span className="text-sm">Back to Login</span>
              </button>
            )}
            <h1 className="text-2xl sm:text-3xl font-semibold text-white mb-2 tracking-tight">
              {pageContent.title}
            </h1>
            <p className="text-gray-400 text-sm leading-relaxed">
              {pageContent.subtitle}
            </p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="bg-red-900 bg-opacity-20 border border-red-800 text-red-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
              <div className="flex">
                <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-xs sm:text-sm">{error}</span>
              </div>
            </div>
          )}

          {/* Success Message */}
          {successMessage && (
            <div className="bg-green-900 bg-opacity-20 border border-green-800 text-green-300 p-3 sm:p-4 mb-4 sm:mb-6 rounded-lg">
              <div className="flex">
                <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-xs sm:text-sm">{successMessage}</span>
              </div>
            </div>
          )}

          {/* LOGIN FORM */}
          {authMode === 'login' && (
            <div className="space-y-4 sm:space-y-6">
              <div>
        <label htmlFor="loginId" className="block mb-2 text-xs font-medium uppercase tracking-widest" style={{ color: palette.textMuted }}>
                  Client ID / Email
                </label>
                <input
                  type="text"
                  id="loginId"
                  name="loginId"
                  value={formData.loginId}
                  onChange={handleChange}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
                  style={{
                    background: palette.surfaceAlt,
                    backdropFilter: 'blur(10px)',
                    fontFamily: 'Lexend, sans-serif',
                    color: palette.textPrimary,
                    borderColor: palette.border
                  }}
                  placeholder="Enter your client identifier"
                  required
                />
              </div>

              <div>
        <label htmlFor="password" className="block mb-2 text-xs font-medium uppercase tracking-widest" style={{ color: palette.textMuted }}>
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
                    style={{
                      background: palette.surfaceAlt,
                      backdropFilter: 'blur(10px)',
                      fontFamily: 'Lexend, sans-serif',
                      color: palette.textPrimary,
                      borderColor: palette.border
                    }}
                    placeholder="Enter your secure password"
                    required
                  />
                  <button
                    type="button"
                    className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center text-sm space-y-2 sm:space-y-0">
                <label className="flex items-center gap-2 cursor-pointer" style={{ color: palette.textMuted }}>
                  <input 
                    type="checkbox" 
                    name="rememberDevice"
                    checked={formData.rememberDevice}
                    onChange={handleChange}
                    className="w-4 h-4 rounded" 
                    style={{ accentColor: '#676DFF' }} 
                  />
                  <span>Remember this device</span>
                </label>
                <button
                  type="button"
                  onClick={() => switchAuthMode('forgotPassword')}
                  className="font-medium transition-colors duration-200 text-left sm:text-right"
                  style={{ color: '#676DFF' }}
                >
                  Reset Password
                </button>
              </div>

              <button
                type="button"
                onClick={handleLoginSubmit}
                disabled={isLoading}
                className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
                style={{
                  background: 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
                  boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
                }}
              >
                {isLoading ? 'Authenticating...' : 'Access Portfolio Dashboard'}
              </button>

              <div className="relative text-center my-5 sm:my-7">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full h-px" style={{ background: `linear-gradient(90deg, transparent, ${palette.border}, transparent)` }} />
                </div>
                <span className="px-4 text-xs relative" style={{ backgroundColor: isLight ? '#eef2ff' : 'var(--bg-base-95)', color: palette.textSubtle }}>or authenticate with</span>
              </div>

              <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-5 sm:mb-7">
                <button
                  type="button"
                  onClick={() => handleSocialLogin('google')}
                  className="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-600 rounded-lg text-gray-300 text-xs font-medium transition-all duration-300 hover:border-purple-500 hover:bg-gray-800"
                  style={{ background: 'rgba(21, 21, 21, 0.6)' }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  <span className="hidden sm:inline">Google SSO</span>
                  <span className="sm:hidden">Google</span>
                </button>
                <button
                  type="button"
                  onClick={() => handleSocialLogin('Microsoft')}
                  className="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-600 rounded-lg text-gray-300 text-xs font-medium transition-all duration-300 hover:border-purple-500 hover:bg-gray-800"
                  style={{ background: 'rgba(21, 21, 21, 0.6)' }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#00BCF2" d="M0 0h11v11H0z"/>
                    <path fill="#00B7F2" d="M13 0h11v11H13z"/>
                    <path fill="#FFB900" d="M0 13h11v11H0z"/>
                    <path fill="#00D800" d="M13 13h11v11H13z"/>
                  </svg>
                  Microsoft
                </button>
              </div>

              <div className="text-center">
                <p className="text-sm text-gray-400">
                  Don't have an account?{' '}
                  <button
                    type="button"
                    onClick={() => switchAuthMode('signup')}
                    className="font-medium transition-colors duration-200"
                    style={{ color: '#676DFF' }}
                  >
                    Sign up
                  </button>
                </p>
              </div>
            </div>
          )}

          {/* SIGNUP FORM - Mobile responsive */}
          {authMode === 'signup' && (
            <div className="space-y-4 sm:space-y-6">
              {/* NAME INPUT */}
              <div>
                <label htmlFor="name" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name || ''}
                  onChange={handleChange}
                  className={`w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                    fieldErrors.name 
                      ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                      : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                  }`}
                  style={{
                    background: 'rgba(21, 21, 21, 0.8)',
                    backdropFilter: 'blur(10px)',
                    fontFamily: 'Lexend, sans-serif'
                  }}
                  placeholder="Enter your full name"
                  required
                />
                {fieldErrors.name && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.name}
                  </p>
                )}
              </div>

              {/* EMAIL INPUT */}
              <div>
                <label htmlFor="email" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleChange}
                  className={`w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                    fieldErrors.email 
                      ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                      : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                  }`}
                  style={{
                    background: 'rgba(21, 21, 21, 0.8)',
                    backdropFilter: 'blur(10px)',
                    fontFamily: 'Lexend, sans-serif'
                  }}
                  placeholder="Enter your email address"
                  required
                />
                {fieldErrors.email && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.email}
                  </p>
                )}
              </div>

              {/* PASSWORD INPUT */}
              <div>
                <label htmlFor="signupPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="signupPassword"
                    name="signupPassword"
                    value={formData.signupPassword || ''}
                    onChange={handleChange}
                    className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                      fieldErrors.signupPassword 
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                        : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                    }`}
                    style={{
                      background: 'rgba(21, 21, 21, 0.8)',
                      backdropFilter: 'blur(10px)',
                      fontFamily: 'Lexend, sans-serif'
                    }}
                    placeholder="Create a secure password"
                    required
                  />
                  <button
                    type="button"
                    className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
                {fieldErrors.signupPassword && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.signupPassword}
                  </p>
                )}
              </div>

              {/* CONFIRM PASSWORD INPUT */}
              <div>
                <label htmlFor="confirmPassword" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword || ''}
                    onChange={handleChange}
                    className={`w-full px-4 sm:px-5 py-3 sm:py-4 pr-12 rounded-xl border text-white text-sm transition-all duration-300 focus:outline-none focus:ring-3 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500 ${
                      fieldErrors.confirmPassword 
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-500' 
                        : 'border-gray-600 focus:border-purple-500 focus:ring-purple-500'
                    }`}
                    style={{
                      background: 'rgba(21, 21, 21, 0.8)',
                      backdropFilter: 'blur(10px)',
                      fontFamily: 'Lexend, sans-serif'
                    }}
                    placeholder="Confirm your password"
                    required
                  />
                  <button
                    type="button"
                    className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-purple-500 hover:bg-purple-500 hover:bg-opacity-10 rounded-md transition-all duration-200"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
                {fieldErrors.confirmPassword && (
                  <p className="text-red-400 text-xs mt-2 flex items-center">
                    <AlertCircle className="w-3 h-3 mr-1" />
                    {fieldErrors.confirmPassword}
                  </p>
                )}
              </div>

              {/* SUBMIT BUTTON */}
              <div className="pt-2">
                <button
                  type="button"
                  onClick={handleSignupSubmit}
                  disabled={isLoading}
                  className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
                  style={{
                    background: isLoading 
                      ? '#4a5568' 
                      : 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
                    boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
                  }}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                      Creating Account...
                    </span>
                  ) : (
                    'Create Account'
                  )}
                </button>
              </div>

              {/* SIGN IN LINK */}
              <div className="text-center">
                <p className="text-sm text-gray-400">
                  Already have an account?{' '}
                  <button
                    type="button"
                    onClick={() => switchAuthMode('login')}
                    className="font-medium transition-colors duration-200"
                    style={{ color: '#676DFF' }}
                  >
                    Sign In
                  </button>
                </p>
              </div>
            </div>
          )}

          {/* FORGOT PASSWORD FORM */}
          {authMode === 'forgotPassword' && (
            <div className="space-y-4 sm:space-y-6">
              <div>
                <label htmlFor="resetEmail" className="block mb-2 text-xs font-medium text-gray-300 uppercase tracking-widest">
                  Email Address
                </label>
                <input
                  type="email"
                  id="resetEmail"
                  name="resetEmail"
                  value={formData.resetEmail}
                  onChange={handleChange}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-xl border border-gray-600 text-white text-sm transition-all duration-300 focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-500 focus:ring-opacity-20 focus:translate-y-[-1px] focus:shadow-lg hover:border-gray-500"
                  style={{
                    background: 'rgba(21, 21, 21, 0.8)',
                    backdropFilter: 'blur(10px)',
                    fontFamily: 'Lexend, sans-serif'
                  }}
                  placeholder="Enter your email address"
                  required
                />
                <p className="text-xs text-gray-500 mt-2">
                  We'll send you a secure link to reset your password
                </p>
              </div>

              <button
                type="button"
                onClick={handleForgotPasswordSubmit}
                disabled={isLoading}
                className="w-full py-3 sm:py-4 px-6 rounded-xl text-white font-semibold text-sm relative overflow-hidden transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl disabled:opacity-50"
                style={{
                  background: 'linear-gradient(135deg, #676DFF 0%, #5A60E8 100%)',
                  boxShadow: '0 8px 25px rgba(103, 109, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
                }}
              >
                {isLoading ? 'Sending Reset Link...' : 'Send Reset Link'}
              </button>

              <div className="text-center">
                <p className="text-sm text-gray-400">
                  Remember your password?{' '}
                  <button
                    type="button"
                    onClick={() => switchAuthMode('login')}
                    className="font-medium transition-colors duration-200"
                    style={{ color: '#676DFF' }}
                  >
                    Sign In
                  </button>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
      `}</style>
    </div>
  );
}

export default Login;